import { buildTheme } from "@/themes/MarketTheme";
import type { PaletteMode } from "@mui/material";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type ColorPref = PaletteMode | "system";

export const colorPrefAtom = atomWithStorage<ColorPref>(
	"mui-color-pref",
	"system",
);

export const systemModeAtom = atom<PaletteMode>("light");

systemModeAtom.onMount = (set) => {
	if (typeof window === "undefined") return;

	const mq = window.matchMedia("(prefers-color-scheme: dark)");
	const handleChange = (e: MediaQueryListEvent) => {
		set(e.matches ? "dark" : "light");
	};

	set(mq.matches ? "dark" : "light");
	if (typeof mq.addEventListener === "function") {
		mq.addEventListener("change", handleChange);
		return () => mq.removeEventListener("change", handleChange);
	}

	const legacy = mq as any;
	legacy.addListener(handleChange);
	return () => legacy.removeListener(handleChange);
};

export const resolvedModeAtom = atom<PaletteMode>((get) => {
	const pref = get(colorPrefAtom);
	return pref === "system" ? get(systemModeAtom) : pref;
});

export const themeAtom = atom((get) => buildTheme(get(resolvedModeAtom)));
themeAtom.debugLabel = "themeAtom";
